<template>
    <el-dialog title="选择转单技师" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false"
        :close-on-press-escape="false" width="70%">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading"
            :default-sort="{ prop: 'waiter_user_id', order: 'descending' }" ref="singleTable" highlight-current-row
            @row-click="transferCurrentChange">

            <el-table-column prop="waiter_user_id" label="技师ID" width="100" sortable></el-table-column>
            <el-table-column prop="avatarUrl" label="技师头像">
                <template slot-scope="scope" v-if="scope.row.avatarUrl">
                    <img :src='scope.row.avatarUrl' alt="" width="50px" height="50px" />
                </template>
            </el-table-column>
            <!-- <el-table-column prop="nickName" label="昵称"></el-table-column> -->
            <el-table-column prop="username" label="姓名/电话" width="150px">
                <template slot-scope="scope">
                    <div>{{ scope.row.username }}</div>
                    <div>{{ scope.row.mobile }}</div>
                </template>
            </el-table-column>
            <!-- <el-table-column prop="supplier.name" label="所属商户">
            </el-table-column> -->
            <el-table-column prop="service_name" label="服务类型">
            </el-table-column>
            <el-table-column prop="working_hours" label="工作时长"></el-table-column>
            <el-table-column prop="city" label="城市"></el-table-column>
            <el-table-column prop="money" label="余额">
                <template slot-scope="scope">
                    <div style="color:red">￥ {{ scope.row.money ? scope.row.money : 0.00 }} 元</div>
                </template>
            </el-table-column>
            <el-table-column prop="order_total" label="订单量">
                <template slot-scope="scope">
                    <div>{{ scope.row.order_total ? scope.row.order_total : 0 }} 单</div>
                </template>
            </el-table-column>
            <el-table-column prop="fare_price" label="车费">
                <template slot-scope="scope">
                    <div style="color:red">￥ {{ scope.row.fare_price ? scope.row.fare_price : 0.00 }} 元</div>
                </template>
            </el-table-column>
            <el-table-column prop="is_success" label="工作状态">
                <template slot-scope="scope">
                    <div v-if="scope.row.is_success == 1" style="color:green">可服务</div>
                    <div v-else-if="scope.row.is_success == 2" style="color:orange">服务中</div>
                    <div v-else style="color：red">休息</div>
                </template>
            </el-table-column>
            <el-table-column prop="is_xr" label="是否新人">
                <template slot-scope="scope">
                    <div v-if="scope.row.is_tj == 0" style="color:red">否</div>
                    <div v-else-if="scope.row.is_tj == 1" style="color:green">是</div>
                    <div v-else style="">--</div>
                </template>
            </el-table-column>
            <el-table-column prop="is_tj" label="是否推荐">
                <template slot-scope="scope">
                    <div v-if="scope.row.is_tj == 0" style="color:red">不推荐</div>
                    <div v-else-if="scope.row.is_tj == 1" style="color:green">推荐</div>
                    <div v-else style="">--</div>
                </template>
            </el-table-column>
            <el-table-column prop="username" label="性别/年龄/身高" width="120px">
                <template slot-scope="scope">
                    <div v-if="scope.row.gender == 1">男性</div>
                    <div v-else>女性</div>
                    <div>{{ scope.row.age ? scope.row.age : '--' }}岁</div>
                    <div v-if="scope.row.height != null">{{ scope.row.height ? scope.row.height : '--' }}cm</div>
                    <div v-if="scope.row.height == null">--cm</div>
                </template>
            </el-table-column>
            <el-table-column prop="lng" label="经度"></el-table-column>
            <el-table-column prop="lat" label="纬度"></el-table-column>

            <!-- <el-table-column fixed="right" label="操作" width="55">
                <template slot-scope="scope">
                    <el-radio v-model="scope.row.selected"></el-radio>
                </template>
            </el-table-column> -->
        </el-table>
        <!--分页-->
        <div class="pagination">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
                :current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper"
                :total="totalDataNumber"></el-pagination>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible">取 消</el-button>
            <el-button type="primary" @click="submit" :disabled="submit_loading">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import OrderApi from "@/api/order.js";
import Technician from "@/api/technician.js";
export default {
    data() {
        return {
            /*是否加载完成*/
            loading: true,
            /*是否显示*/
            dialogVisible: false,
            /*是否正在提交*/
            submit_loading: false,
            /*列表数据*/
            tableData: [],
            /*一页多少条*/
            pageSize: 15,
            /*一共多少条数据*/
            totalDataNumber: 0,
            /*当前是第几页*/
            curPage: 1,
            waiter_user_id: '',
            shopSupplierId: null,
        };
    },
    props: ["open_orderTransfer", "form"],
    created() {
        // yong
        this.shopSupplierId = this.form.shopSupplierId;
        this.orderId = this.form.orderId;

        if (this.shopSupplierId) {
            this.getTableList()
        }
        this.dialogVisible = this.open_orderTransfer;
    },
    methods: {
        setCurrent(row) {
            this.$refs.singleTable.setCurrentRow(row);
        },
        transferCurrentChange(val) {

            this.waiter_user_id = val.waiter_user_id;
            // this.tableData.forEach(item => {
            //     item.selected = false; // 将所有行的 selected 属性设置为 false
            // });
            // val.selected = true; // 将当前点击的行的 selected 属性设置为 true
            // this.tableData.forEach(item => {
            //     this.$set(item, 'selected', false); // 将所有行的 selected 属性设置为 false
            // });
            // this.$set(val, 'selected', true); // 将当前点击的行的 selected 属性设置为 true
            console.log('========', val, val.waiter_user_id)
        },
        /*选择第几页*/
        handleCurrentChange(val) {
            let self = this;
            self.curPage = val;
            self.loading = true;
            self.getTableList();
        },

        /*每页多少条*/
        handleSizeChange(val) {
            this.curPage = 1;
            this.pageSize = val;
            this.getTableList();
        },
        /*获取列表*/
        getTableList() {
            let self = this;
            let Params = {};
            Params.shopSupplierId = self.shopSupplierId;
            Params.pageIndex = self.curPage;
            Params.pageSize = self.pageSize;
            Technician.getnewWaiter(Params, true)
                .then(data => {
                    self.loading = false;
                    self.supplierList = data.data.supplier;
                    let service_typeList = data.data.service_type;
                    self.tableData = data.data.list.data.map(item => {
                        item.service_name = "";
                        service_typeList.forEach(i => {
                            if (i.id == item.serviceId) {
                                item.service_name = i.name;
                            }
                        });
                        item.selected = false; // 添加 selected 属性，默认为 false
                        return item;
                    });
                    self.totalDataNumber = data.data.list.total;
                })
                .catch(error => {
                    self.loading = false;
                });
        },

        // getTableList() {
        //     let self = this;
        //     let Params = {};
        //     Params.shopSupplierId = self.shopSupplierId;
        //     Params.pageIndex = self.curPage;
        //     Params.pageSize = self.pageSize;
        //     Technician.getnewWaiter(Params, true)
        //         .then(data => {
        //             self.loading = false;
        //             self.supplierList = data.data.supplier;
        //             let service_typeList = data.data.service_type;
        //             self.tableData = data.data.list.data.map(item => {
        //                 item.service_name = "";
        //                 service_typeList.forEach(i => {
        //                     if (i.id == item.serviceId) {
        //                         item.service_name = i.name;
        //                     }
        //                 });
        //                 return item;
        //             });
        //             self.totalDataNumber = data.data.list.total;
        //         })
        //         .catch(error => {
        //             self.loading = false;
        //         });
        // },
        submit() {
            let self = this;
            let params = {};
            params.orderId = self.orderId
            params.waiter_user_id = self.waiter_user_id

            self.submit_loading = true;
            OrderApi.transferOrder(params, true)
                .then(data => {
                    self.submit_loading = false;
                    self.$message({
                        message: "恭喜你，修改成功",
                        type: "success"
                    });
                    self.dialogFormVisible(true);
                })
                .catch(error => {
                    self.submit_loading = false;
                });

        },
        /*关闭弹窗*/
        dialogFormVisible(e) {
            if (e) {
                this.$emit("closeDialog", {
                    type: "success",
                    openDialog: false
                });
            } else {
                this.$emit("closeDialog", {
                    type: "error",
                    openDialog: false
                });
            }
        }
    }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/order/order/dialog/order-transfer.vue